module.exports = __webpack_public_path__ + "img/r-2-btn.f033e305.png";